
import { defineComponent, PropType } from "vue";
import firebase from "firebase/compat/app";
import "firebase/compat/functions";
import dayjs from "dayjs";
import { TelegramBotUserData } from "@/store/User/UserInterfaces";

export default defineComponent({
  name: "telegram-unlink",
  props: {
    username: { type: String, required: true },
    telegramBotUserData: {
      type: Object as PropType<TelegramBotUserData | undefined>,
      default: undefined,
    },
  },
  emits: ["telegramUnlinked", "error"],
  data() {
    return {
      linkedData: this.telegramBotUserData as TelegramBotUserData | undefined,
      enabled: false,
      confirming: false,
      unlinking: false,
      reason: "",
      resultMessage: "",
      resultSuccess: false,
    };
  },
  watch: {
    telegramBotUserData(val: TelegramBotUserData | undefined) {
      this.linkedData = val;
      this.confirming = false;
      this.resultMessage = "";
      this.reason = "";
    },
  },
  methods: {
    formatDate(value: string | undefined): string {
      if (!value) return "N/A";
      return dayjs(value).format("DD/MM/YYYY HH:mm");
    },
    cancelConfirm() {
      this.confirming = false;
      this.reason = "";
    },
    doUnlink() {
      this.unlinking = true;
      this.resultMessage = "";
      firebase
        .functions()
        .httpsCallable("TelegramFuncs-unlinkTelegramAccount")({
          username: this.username.toLowerCase(),
          reason: this.reason.trim() || undefined,
        })
        .then((response) => {
          const data = response.data;
          if (data.OPCODE === "SUCCESS") {
            this.linkedData = undefined;
            this.resultSuccess = true;
            this.resultMessage =
              "Cuenta de Telegram desvinculada exitosamente. El usuario puede vincular una cuenta diferente usando el bot.";
            this.$emit("telegramUnlinked");
          } else {
            this.resultSuccess = false;
            this.resultMessage =
              data.message || "Error al desvincular cuenta de Telegram";
          }
        })
        .catch((error: any) => {
          console.error("Error unlinking Telegram account:", error);
          this.$emit(
            "error",
            "Error al desvincular Telegram",
            error.message || "Error desconocido"
          );
        })
        .finally(() => {
          this.unlinking = false;
          this.confirming = false;
          this.reason = "";
        });
    },
  },
});
